import { Box } from '@mui/material';
import { COPY } from '../copy';
import { telHref } from '../format';
import { useLayoutStyles } from '../layouts/layout-context';
import { DocumentIcon, MailIcon, PhoneIcon, SparkIcon } from '../primitives/icons';
import { Wrap } from '../primitives/wrap';
import type { LandingPagePartner } from '../types';

export const SiteFooter = ({ partner }: { partner?: LandingPagePartner }) => {
  const s = useLayoutStyles('chrome');
  const hasContact = Boolean(partner?.phone || partner?.email || partner?.termsOfServiceUrl);

  return (
    <Box component="footer" sx={s.footer}>
      {/* Skipped entirely when the brand has no contact details, rather than leaving a blank band. */}
      {hasContact ? (
        <Wrap>
          <Box sx={s.footerContact}>
            {partner?.phone ? (
              <Box component="a" href={telHref(partner.phone)} sx={s.footerLink}>
                <PhoneIcon sx={s.footerLinkIcon} />
                {COPY.textOrCall(partner.phone)}
              </Box>
            ) : null}
            {partner?.email ? (
              <Box component="a" href={`mailto:${partner.email}`} sx={s.footerLink}>
                <MailIcon sx={s.footerLinkIcon} />
                {partner.email}
              </Box>
            ) : null}
            {partner?.termsOfServiceUrl ? (
              <Box
                component="a"
                href={partner.termsOfServiceUrl}
                target="_blank"
                rel="noopener noreferrer"
                sx={s.footerLink}
              >
                <DocumentIcon sx={s.footerLinkIcon} />
                {COPY.terms}
              </Box>
            ) : null}
          </Box>
        </Wrap>
      ) : null}

      <Box sx={s.footerBar}>
        <Wrap>
          <Box sx={s.footerLegal}>
            <span>{COPY.copyright(new Date().getFullYear(), partner?.name)}</span>
            <Box component="span" sx={s.powered}>
              <SparkIcon />
              {COPY.poweredBy} <b>{COPY.provision}</b>
            </Box>
          </Box>
        </Wrap>
      </Box>
    </Box>
  );
};
